export default {
  NotificationHtml: '<b>Công ty cổ phần MISA</b> đã xuất hóa đơn cho <b>{0}</b> (Mã QHNS: {1}). Quý vị vui lòng làm thủ tục thanh toán để không bị gián đoạn công việc.</b>',
  ContactHtml: `Mọi thủ tục vướng mắc về thanh toán, Quý đơn vị liên hệ: <span class="color-green">{0} - {1}</span>`,
  ContactHtmlNoDetail: `Mọi thủ tục vướng mắc về thanh toán, Quý đơn vị liên hệ: <span class="color-green">{0}</span>`,
  DebtReminder: 'Thông báo nhắc thanh toán',
  ExportReminder: 'Thông báo đã xuất hóa đơn tài chính',
  GenVoucher: 'Sinh giấy rút',
  LastNote: 'Nếu Quý đơn vị đã thanh toán vui lòng bỏ qua thông báo này.',
  Transfer: 'Chuyển khoản',
  CashWithdraw: 'Rút tiền mặt',
  ExportInvoiceViewing: 'Xem hóa đơn tài chính MISA xuất',
  NotValidSelected: "Bạn cần chọn ít nhất một dòng dữ liệu."
}